import Vue from 'vue';
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        cardbackground: '#F8F8F8',
        tertiary: '#60ADDE',
        accent: '#E67900',
        secondary: '#EF6B44',
        success: '#00A57B',
        primary: '#60ADDE',
        info: '#1E6E80',
        warning: '#DBA617',
        error: '#F50000'
      },
      dark: {
        cardbackground: '#2F2F2F',
        tertiary: '#60ADDE',
        accent: '#E67900',
        secondary: '#EF6B44',
        success: '#00A57B',
        primary: '#60ADDE',
        info: '#1E6E80',
        warning: '#DBA617',
        error: '#F50000'
      }
    }
  }
});